import React from 'react';
import { Editor as TipTapEditorCore } from '@tiptap/react';
import './TipTapToolbar.css';

interface TipTapToolbarProps {
  editor: TipTapEditorCore | null;
  disabled?: boolean;
}

export const TipTapToolbar: React.FC<TipTapToolbarProps> = ({ editor, disabled = false }) => {
  if (!editor) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className={`tiptap-bold ${editor.isActive('bold') ? 'ql-active' : ''}`}
        onClick={() => editor.chain().focus().toggleBold().run()}
        disabled={disabled}
        title="Bold"
      />
      <button
        type="button"
        className={`tiptap-italic ${editor.isActive('italic') ? 'ql-active' : ''}`}
        onClick={() => editor.chain().focus().toggleItalic().run()}
        disabled={disabled}
        title="Italic"
      />
      <button
        type="button"
        className={`tiptap-underline ${editor.isActive('underline') ? 'ql-active' : ''}`}
        onClick={() => editor.chain().focus().toggleMark('underline').run()}
        disabled={disabled}
        title="Underline"
      />
      <button
        type="button"
        className={`tiptap-list ${editor.isActive('orderedList') ? 'ql-active' : ''}`}
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        disabled={disabled}
        value="ordered"
        title="Ordered List"
      />
      <button
        type="button"
        className={`tiptap-list ${editor.isActive('bulletList') ? 'ql-active' : ''}`}
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        disabled={disabled}
        value="bullet"
        title="Bullet List"
      />
    </>
  );
};

export default TipTapToolbar;
